import { useMemo } from 'react';

import { useDismissViewStateMutation, useGetViewStatesQuery } from './api/viewStateApi';

export type DismissableViewMode = 'one-time' | 'dismiss-until-dismissed';

export interface UseDismissableViewArgs {
  key: string;
  mode: DismissableViewMode;
}

export interface UseDismissableViewResult {
  isVisible: boolean;
  isLoading: boolean;
  dismiss: () => Promise<void>;
}

export const useDismissableView = ({
  key,
  mode: _mode,
}: UseDismissableViewArgs): UseDismissableViewResult => {
  const keys = useMemo(() => [key], [key]);
  const { data, isLoading, isFetching } = useGetViewStatesQuery(keys);
  const [dismissMutation] = useDismissViewStateMutation();

  const dismissedAt = data?.[key]?.dismissed_at ?? null;
  const isVisible = dismissedAt === null;

  return {
    isVisible,
    isLoading: isLoading || isFetching,
    dismiss: async () => {
      await dismissMutation({ key }).unwrap();
    },
  };
};
